import { Component, OnInit } from "@angular/core";
import { FinanzasService } from 'app/finanzas/finanzas.service';
import { Empresa } from 'app/finanzas/entidades';


@Component({
    selector: 'app-valoracion', 
    templateUrl: './valoracion.component.html', 
    styleUrls: ['./valoracion.component.css']
})


export class ValoracionComponent implements OnInit{

    empresas : Array<Empresa>

    constructor( private service: FinanzasService  ){}

    ngOnInit(   ){

        this.service.getEmpresas().subscribe(  (resp : Array<Empresa>) => { this.empresas = resp}  )

    }

}